import 'phaser'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { phaserUtil } from '../engine/phaserUtil-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { cargoesData } from '../entities/cargoesData-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { l } from '../lib/imports'
import { IMachineData } from '../machines/machinesData'
import { common } from '../main/common-sidecar'
import { fi32 } from '../main/frameInfo'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { cursors } from '../ui/cursors-sidecar'
import { uiBuild } from '../ui/uiBuild-sidecar'
import { ITileDataShip } from './tilesDataShip'

export interface IBuildSelector extends IEntity {
  x: number
  y: number
  image: Phaser.GameObjects.Image
  images: Phaser.GameObjects.Image[]
  machineData: IMachineData | null
  tileData: ITileDataShip | null
  cargoType: ICargoType | null
}

const objs: IBuildSelector[] = []

const errorFrame = fi32(5, 0, 0)
export function create(
  x: number,
  y: number,
  machineData: IMachineData | null,
  tileData: ITileDataShip | null,
  cargoType: ICargoType | null,
): IBuildSelector {
  let id = common.createId()

  let frame =
    machineData?.frames[0] ||
    tileData?.frameInfo ||
    (cargoType && stacks.frame) ||
    errorFrame

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().ui,
    frame,
    x,
    y,
  )

  let images: Phaser.GameObjects.Image[] = []

  if (cargoType) {
    let cd = cargoesData.dataMapName[cargoType]

    let spread = 12
    let offsets = [
      [0, -spread],
      [-spread / 2, 0],
      [spread / 2, 0],
    ]

    for (let i = 0; i < 3; i++) {
      let image2 = spriteMap.createImageFromFrameInfo(
        layers.getLayers().ui,
        cd.frame,
        x + offsets[i][0],
        y + offsets[i][1],
      )
      images.push(image2)
    }
  }

  let obj: IBuildSelector = {
    eType: 'build-selector',
    id,
    x,
    y,
    image,
    images,
    machineData,
    tileData,
    cargoType,
    isDead: false,
  }
  objs.push(obj)

  phaserUtil.setInteractive(obj.image)

  obj.image.on('pointerover', () => {
    if (obj.machineData) {
      let d = obj.machineData
      uiBuild.setDesc(d.buildName, d.buildDesc)

      // cursors.setToMachine(s.cursor, obj.machineData)
    }
    if (obj.tileData) {
      let d = obj.tileData
      uiBuild.setDesc(d.buildName || 'Unk', d.buildDesc || 'Unk')
      // cursors.setToTile(s.cursor, obj.tileData)
    }
    if (obj.cargoType) {
      uiBuild.setDesc('Stack', 'Organize ' + obj.cargoType)
    }
  })
  obj.image.on('pointerdown', () => {
    clickEater.tempEat()

    let s = scene.getContext()
    uiBuild.setOpen(false)

    tileMapEditor.setMode('build')
    if (obj.machineData) {
      cursors.setToMachine(s.cursor, obj.machineData)
    }
    if (obj.tileData) {
      cursors.setToTile(s.cursor, obj.tileData)
    }
    if (obj.cargoType) {
      cursors.setToStack(s.cursor, obj.cargoType)
    }
  })

  return obj
}

export function setVisible(obj: IBuildSelector, isVisible: boolean) {
  obj.image.visible = isVisible
  l.forEach(obj.images, (d) => {
    d.visible = isVisible
  })
}

export function kill(obj: IBuildSelector) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    c.isDead = true
  })
}
export function updateAll() {
  objs.forEach((c) => {
    // update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    if (c.image) {
      c.image.destroy()
    }
    l.forEach(c.images, (d) => d.destroy())
  })
}
